<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12 text-center">
            <footer class="bg-light">
            <p class="nav-link">Design and Developed By:<a href="wwww.dotlinesoftware.com">Dotline Software</a></p>               
            </footer>
        </div>
    </div>
</div>
